import React from "react";
import { SecondaryButtonLink } from "~assets/frontend/elements/button-link/ButtonLink";
import { CompHeadline } from "~assets/frontend/components/comp-headline";
import { useImageStruct } from "~assets/frontend/_util/hooks/useImageStruct";
import { motion } from "framer-motion";
import { ResponsiveImage } from "~assets/frontend/elements/responsive-image/ResponsiveImage";
const sizes = {
    extraSmall: {
        w: 588,
        h: 755,
    },
    small: {
        w: 755,
        h: 960,
    },
    medium: {
        w: 960,
        h: 1080,
    },
    large: {
        w: 1588,
        h: 1080,
    },
    extraLarge: {
        w: 1920,
        h: 1080,
    },
};
const badgeSize = {
    extraSmall: {
        h: 90,
    },
    medium: {
        h: 100,
    },
    extraLarge: {
        h: 140,
    },
};
export const StageCarouselSlide = ({ intro, headline, image, buttonLink, awards, badgeStruct }) => {
    const imageSrc = useImageStruct(image, sizes);
    const variantsContainer = {
        enter: {
            y: "84px",
        },
        center: {
            y: "0px",
            transition: {
                ease: "easeInOut",
                duration: 0.8,
                delay: 1.6,
                staggerChildren: 0.8,
                delayChildren: 0.8,
            },
        },
        exit: {
            y: "0px",
        },
    };
    const variantsHeadline = {
        enter: {
            opacity: 0,
        },
        center: {
            opacity: 1,
            transition: {
                ease: "easeInOut",
                duration: 0.8,
            },
        },
        exit: {
            opacity: 0,
            transition: {
                ease: "easeInOut",
                duration: 0.8,
            },
        },
    };
    const variantsIntro = {
        enter: {
            opacity: 0,
        },
        center: {
            opacity: 1,
            transition: {
                ease: "easeInOut",
                duration: 0.8,
            },
        },
        exit: {
            opacity: 0,
            transition: {
                ease: "easeInOut",
                duration: 0.8,
            },
        },
    };
    const trackingEvent = {
        name: "ui",
        payload: {
            ui_function: "navigate",
            ui_action: "link",
            ui_component: "mod-stage_carousel",
            ui_target: buttonLink ? buttonLink.href : "",
        },
    };
    return (React.createElement("div", { className: "relative h-full", draggable: "false" },
        imageSrc && (React.createElement(ResponsiveImage, { _id: image._id, _name: image._name, caption: "", copyright: image.copyright, mask: image.mask, fieldValue: image.fieldValue, sizes: sizes, additionalAttributes: { draggable: false }, wrapperClass: "h-full w-full", pictureClass: "h-full w-full", imgClass: "absolute ml-auto mr-auto h-full w-full object-cover brightness-75" })),
        React.createElement("div", { className: "dark container" },
            React.createElement(motion.div, { className: "container absolute bottom-1/4 left-0 right-0 mx-auto dark:text-white", variants: variantsContainer },
                React.createElement(motion.div, { className: "z-badge flex items-center justify-end md:pr-48" },
                    !(badgeStruct === null || badgeStruct === void 0 ? void 0 : badgeStruct.link) && (badgeStruct === null || badgeStruct === void 0 ? void 0 : badgeStruct.image) && (React.createElement(ResponsiveImage, { _name: badgeStruct.image._name, fieldValue: badgeStruct.image.fieldValue, caption: null, mask: badgeStruct.image.mask, copyright: badgeStruct.image.copyright, _id: badgeStruct.image._id, sizes: badgeSize })),
                    (badgeStruct === null || badgeStruct === void 0 ? void 0 : badgeStruct.link) && (badgeStruct === null || badgeStruct === void 0 ? void 0 : badgeStruct.image) && (React.createElement("a", { href: badgeStruct.link, title: badgeStruct.name },
                        React.createElement(ResponsiveImage, { _name: badgeStruct.image._name, fieldValue: badgeStruct.image.fieldValue, caption: null, mask: badgeStruct.image.mask, copyright: badgeStruct.image.copyright, _id: badgeStruct.image._id, sizes: badgeSize })))),
                React.createElement(motion.div, { className: "md:max-w-lg xl:max-w-4xl" },
                    React.createElement(motion.div, { variants: variantsHeadline },
                        React.createElement(CompHeadline, { headline: headline.headline, overline: headline.overline, headlineTag: headline.headlineTag, headlineAppearance: headline.headlineAppearance, _name: "HeadlineStruct", _id: "", _isFrontendComponentStruct: true })),
                    React.createElement(motion.div, { variants: variantsIntro },
                        intro && React.createElement("p", { className: "headline-2" }, intro),
                        awards && (React.createElement("div", { className: "mb-24 flex flex-row flex-wrap gap-24" }, awards.map((award) => {
                            const awardImage = (React.createElement(ResponsiveImage, Object.assign({ imgClass: "" }, award.image, { caption: "", sizes: { extraSmall: { h: 80 }, extraLarge: { h: 100 } } })));
                            return (React.createElement("div", { key: award.name },
                                award.link && (React.createElement("a", { href: award.link, title: award.name }, awardImage)),
                                !award.link && awardImage));
                        }))),
                        buttonLink && React.createElement(SecondaryButtonLink, Object.assign({}, buttonLink, { trackingEvent: trackingEvent }))))))));
};
